
import { NavLink, Nav } from "react-router-dom";
import "./index.scss"

export default function Header(){


    return (<header>
     <p className="header-title">React Gamification Demos</p>
     <nav>
        <NavLink className={({ isActive }) => (isActive ? 'is-active' : '')} to="/" >Home</NavLink>
        <NavLink className={({ isActive }) => (isActive ? 'is-active' : '')} to="/calc-quiz">Calculator Quiz</NavLink>
        <NavLink className={({ isActive }) => (isActive ? 'is-active' : '')} to="/elevens-game">Elevens Card Game</NavLink>
        <NavLink className={({ isActive }) => (isActive ? 'is-active' : '')} to="/match-2-game">Match 2 Game</NavLink>
        <NavLink className={({ isActive }) => (isActive ? 'is-active' : '')} to="/space-shooter">Space Shooter</NavLink>
        <NavLink className={({ isActive }) => (isActive ? 'is-active' : '')} to="/board-game">Board Game</NavLink>
        </nav>

       
    </header>);
}